import React from "react";
import Scrollspy from "react-scrollspy";

const Navbar = () => {
  const handleUpdate = (e) => {
    if (e) {
      // document.querySelector('#home').classList.remove('active-section');
      // document.querySelector('#about').classList.remove('active-section');
      // document.querySelector('#projects').classList.remove('active-section');
      e.classList.add("active-section");
    }
  };
  return (
    <header className="navbar">
      <h1 className="brand">Kartik Gupta</h1>
      <h1 className="brand-mobile">KG</h1>
      <Scrollspy
        items={["home", "about", "projects"]}
        currentClassName="active"
        onUpdate={handleUpdate}
        offset={-500}
      >
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About Me</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
      </Scrollspy>
    </header>
  );
};

export default Navbar;
